/**
 * Where you stood on the board when a visit began, so Home can say how far you
 * climbed by the end of it ("+1,240 points, up from 22nd to 19th").
 *
 * Kept in the browser rather than in a table: it is one number per visit, only
 * this phone ever reads it, and losing it costs a line of the recap, nothing
 * else. Written once per visit, the first time Home sees your rank during it.
 */
export interface SessionStart {
  checkedInAt: string
  rank: number
  score: number
}

const key = (gymId: string) => `sc:session-start:${gymId}`

export function readSessionStart(gymId: string, checkedInAt: string): SessionStart | null {
  try {
    const raw = localStorage.getItem(key(gymId))
    if (!raw) return null
    const value = JSON.parse(raw) as SessionStart
    return value.checkedInAt === checkedInAt ? value : null
  } catch {
    return null
  }
}

export function rememberSessionStart(gymId: string, start: SessionStart): void {
  if (readSessionStart(gymId, start.checkedInAt)) return
  try {
    localStorage.setItem(key(gymId), JSON.stringify(start))
  } catch {
    // Storage blocked: the recap just leaves out the rank change.
  }
}
